var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"index-main"},[_c('haier-search'),_vm._l((_vm.componentList),function(item){return _c(item.code,{key:item.name,tag:"component",attrs:{"cmsData":item.cmsData}})})],2)
}
var staticRenderFns = []

export { render, staticRenderFns }